export default {
  claims: null,
  _claim: null
}
